import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hostel',
  templateUrl: './hostel.component.html',
  styleUrls: ['./hostel.component.scss']
})
export class HostelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
